import { Base64 } from 'js-base64'
import { sm2 } from 'sm-crypto'

function stringToHex (str) {
  let hex = ''
  for (let i = 0; i < str.length; i++) {
    const charValue = str.charCodeAt(i).toString(16)
    hex += charValue.length < 2 ? `0${charValue}` : charValue
  }
  return hex
}

/**
 * 16进制还原
 * @param hex
 */
function hexToStr (hex) {
  let str = ''
  for (let i = 0; i < hex.length; i += 2) {
    const char = hex.substr(i, 2)
    const code = parseInt(char, 16)
    str += String.fromCharCode(code)
  }
  return str
}

// await sm2.initRNGPool();
const PUBLIC_KEY =
    'BFR3+ZYrMlwQIwFrJBk5AgfqtJciyh+3tt3DCuJoEgPjck1NCoR8LYGiMvbdnw6N+JqZ+ts1LEAF29b7ZZc+wHE='
const publicKey = stringToHex(Base64.atob(PUBLIC_KEY))

// SM2解密私钥D参数
const PRIVATE_KEY_D = '00d0242f0bcbd05beb53b0c7c3db7daa01c5d2b406e8cc6e94671771812b9e7568'

/**
 * SM2加密
 * @param plainText 明文
 * @returns 加密后的密文（Base64编码的UTF-8字符串）
 */
export function sm2Encrypt (plainText) {
  if (plainText === '' || plainText === null || plainText === undefined) {
    return plainText
  }
  try {
    let msg = plainText
    if (typeof plainText !== 'string') {
      msg = JSON.stringify(plainText)
    }
    // 加密结果
    const encryptData = sm2.doEncrypt(msg, publicKey, 0)
    const encrypt = `04${encryptData}`
    // return Base64.btoa(hexToStr(encrypt))
    //     .replace(/\+/g, '-')
    //     .replace(/\//g, '_')
    //     .replace(/=+$/, '');
    return `enc(${Base64.btoa(hexToStr(encrypt))
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '')})`
  } catch (error) {
    console.error('SM2加密失败:', error)
  }
}

/**
 * SM2解密
 * @param cipherText 密文（Base64编码的密文字符串）
 * @returns 解密后的明文
 */
export function sm2Decrypt (cipherText) {
  try {
    // 还原URL-safe字符
    const base64Content = cipherText.replace(/-/g, '+').replace(/_/g, '/')

    // 补充Base64填充字符
    const paddedBase64 = base64Content + '='.repeat((4 - (base64Content.length % 4)) % 4)

    // Base64解码并转换为16进制
    const hexContent = stringToHex(Base64.atob(paddedBase64))

    // 去掉04前缀
    if (!hexContent.startsWith('04')) {
      throw new Error('密文格式错误，缺少04前缀')
    }
    const encryptDataHex = hexContent.slice(2)

    // SM2解密
    const decryptedText = sm2.doDecrypt(encryptDataHex, PRIVATE_KEY_D, 0)

    return decryptedText
  } catch (error) {
    console.error('SM2解密失败:', error)
    throw error
  }
}



// WEBPACK FOOTER //
// ./src/utils/sm2Util.js